export enum FormLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
  Inline = 'inline'
}
